import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import PostHogProvider from "./providers/PostHogProvider";
import { CookieConsentProvider } from "./providers/CookieConsentProvider";
import { CookieConsent } from "./components/CookieConsent";
import Index from "./pages/Index";
import AIBootcamp from "./pages/AIBootcamp";
import Resources from "./pages/Resources";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import NotFound from "./pages/NotFound";
import SignupPage from "./components/pages/signup/SignupPage";
import ConsultationThankYou from "./pages/thank-you/ConsultationThankYou";
import BootcampThankYou from "./pages/thank-you/BootcampThankYou";
import ExpertThankYou from "./pages/thank-you/ExpertThankYou";
import Downloads from "./pages/Downloads";
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <HelmetProvider>
        <CookieConsentProvider>
          <BrowserRouter>
            <PostHogProvider>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/ai-bootcamp" element={<AIBootcamp />} />
                <Route path="/resources" element={<Resources />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-use" element={<TermsOfUse />} />
                <Route path="/signup" element={<SignupPage />} />
                <Route path="/thank-you/consultation" element={<ConsultationThankYou />} />
                <Route path="/thank-you/bootcamp" element={<BootcampThankYou />} />
                <Route path="/thank-you/expert" element={<ExpertThankYou />} />
                <Route path="/downloads" element={<Downloads />} />
                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Routes>
              <Toaster />
              <CookieConsent />
            </PostHogProvider>
          </BrowserRouter>
        </CookieConsentProvider>
      </HelmetProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
